import { TextField as MuiTextField, TextFieldProps } from '@mui/material';
import { FormikProps } from 'formik';

interface CustomTextFieldProps extends Omit<TextFieldProps, 'name'> {
  name: string;
  formik: FormikProps<any>;
}

export default function TextField({ formik, name, ...props }: CustomTextFieldProps) {
  const error = formik.touched[name] && Boolean(formik.errors[name]);
  const helperText = formik.touched[name] && formik.errors[name];

  return (
    <MuiTextField
      fullWidth
      size="small"
      margin="normal"
      {...props}
      name={name}
      value={formik.values[name]}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      error={error}
      helperText={helperText as string}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '10px',
          '&:hover fieldset': {
            borderColor: '#e53935',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#e53935',
          },
        },
        '& .MuiInputLabel-root.Mui-focused': {
          color: '#e53935',
        },
        mt: 0,
        mb: 0,
        ...props.sx,
      }}
    />
  );
}
